import Repository from "@/plugins/axios";

export default {
  // Получить страницу
  getPage(ident) {
    return Repository.get(`/custom-page/${ident}`);
  },
};
